
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { motion } from "framer-motion";
import helpers from "utils/helpers";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import OInputField from "components/reusable/OInputField";
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from "hooks/useToastContext";
import React, { useContext, useEffect, useTransition } from "react";
import AuthContext from "context/AuthContext";
import { findIndex, isEmpty } from "lodash";

export default function ServiceForm() {
  const { t } = useTranslation();
  const [isPending, setTransition] = useTransition()

  const { updatePageName } = useContext(AuthContext);
  const location = useLocation()
  let defaultValue = location?.state || {}
  const isView = location?.pathname == '/service-price-manager/view'
  const navigate = useNavigate()
  const {
    register,
    control,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange", shouldFocusError: true,
    defaultValues: {
      price: [{ status:true,price: "", startDistance: "0", endDistance: "" }],
      priceIncrementAsPerDistance: [{status:true, percentage: '', min: "0", max: "" }],
    },
    shouldFocusError: false,
  });

  useEffect(() => {
    updatePageName(t('SERVICE_PRICE_MANAGER'))

  }, [location])

  const notification = useToastContext();

  const { fields: fields1 } = useFieldArray({
    control,
    name: "price",
  });

  const { fields: fields2, } = useFieldArray({
    control,
    name: "priceIncrementAsPerDistance",
  });

  const getServiceMasterSP = async () => {
    try {
      const resp = await apiGet(apiPath.getServiceDetails + '/' + location?.state?.spService?._id)
      if (resp?.data?.message) {
        const finalDropOf = location?.state?.dropOffPriceIncrementAsPerDistance?.map((res, index) => ({ ...res, price: resp?.data?.results?.dropOffPriceIncrementAsPerDistance?.[index]?.price,status:(resp?.data?.results?.dropOffPriceIncrementAsPerDistance?.[index]?.status=='active'||resp?.data?.results?.dropOffPriceIncrementAsPerDistance?.[index]?.status==undefined)?(resp?.data?.results?.priceIncrementAsPerDistance?.[index]?.status==undefined||resp?.data?.results?.dropOffPriceIncrementAsPerDistance?.[index-1]?.status=='inactive')?false: true:false }))
        const finalPriceIncrement = location?.state?.priceIncrementAsPerDistance?.map((res, index) => ({ ...res, percentage: resp?.data?.results?.priceIncrementAsPerDistance?.[index]?.percentage,status:(resp?.data?.results?.priceIncrementAsPerDistance?.[index]?.status=='active'||resp?.data?.results?.priceIncrementAsPerDistance?.[index]?.status==undefined)?(resp?.data?.results?.priceIncrementAsPerDistance?.[index]?.status==undefined||resp?.data?.results?.priceIncrementAsPerDistance?.[index-1]?.status=='inactive')?false:true:false }))      
        const editItem = {
          ...location?.state,
          basePrice: resp?.data?.results?.basePrice,
          ...(finalDropOf && { price: finalDropOf }),
          ...(finalPriceIncrement && { priceIncrementAsPerDistance: finalPriceIncrement }),
        }
        reset(editItem)
        return
      }

    } catch (err) {
      console.log('errrrrr', err)
    }

  }

  useEffect(() => {
    if (!isEmpty(location?.state)) {
      if (location?.state?.spServiceStatus !== '') {
        getServiceMasterSP()
      } else {
        const editItem = {
          ...location?.state,
          ...(location?.state?.priceIncrementAsPerDistance && { priceIncrementAsPerDistance: location?.state?.priceIncrementAsPerDistance?.map((res,i) => ({...res,status: true, })) }),
          ...(location?.state?.dropOffPriceIncrementAsPerDistance && { price: location?.state?.dropOffPriceIncrementAsPerDistance?.map((res) => ({status:true, startDistance: res?.startDistance, endDistance: res?.endDistance, price: '' })) }),
        }
        reset(editItem)
      }


    } else if (helpers.andOperator(isEmpty(location?.state), helpers.orOperator(location?.pathname == '/service-price-manager/edit', location?.pathname == '/service-price-manager/view'))) {
      navigate('/service-price-manager')
    }
  }, [location])

  const onSubmit = async (data) => {
    const transformed = {
      serviceId: location?.state?._id,
      basePrice: data?.basePrice,
      dropOffPriceIncrementAsPerDistance: data?.price?.map((res) => ({status:helpers.ternaryCondition(res?.status,'active','inactive'), price: res?.price, startDistance: res?.startDistance, endDistance: res?.endDistance })),
      priceIncrementAsPerDistance: data?.priceIncrementAsPerDistance?.map((res) => ({status:helpers.ternaryCondition(res?.status,'active','inactive'), max: res?.max, min: res?.min, percentage: res?.percentage }))
    };

    setTransition(async () => {
      try {
        const res = await apiPost(`${apiPath.editSPServicePrice}`, transformed)
        if (res.data.success) {
          reset()
          notification.success(res?.data?.message);
          navigate('/service-price-manager')
          return
        }
        notification.error(res?.data?.message);
      } catch (err) {
        console.error("err:", err);
      }
    })
  };




  const handleStatusChange = (e, index) => {
    const checked = e.target.checked;
    const items = watch("priceIncrementAsPerDistance");
      if (!checked) {
      items.forEach((item, idx) => {
        if (idx >= index) {
          setValue(`priceIncrementAsPerDistance.${idx}.status`, false, { shouldValidate: true });
        }
      });
      return;
    }
  
    for (let i = 0; i < index; i++) {
      if (!items?.[i]?.status) {
        return; 
      }
    }
      setValue(`priceIncrementAsPerDistance.${index}.status`, true, { shouldValidate: true });
  };
  

const handleStatusChangeDrop=(e, index)=>{
  const checked = e.target.checked;
  const items = watch("price");
    if (!checked) {
    items.forEach((item, idx) => {
      if (idx >= index) {
        setValue(`price.${idx}.status`, false, { shouldValidate: true });
      }
    });
    return;
  }

  for (let i = 0; i < index; i++) {
    if (!items?.[i]?.status) {
      return; 
    }
  }
    setValue(`price.${index}.status`, true, { shouldValidate: true });
}


  return (
    <div className=" min-h-screen  bg-gradient-to-br from-gray-100 to-gray-200 p-6 md:p-10">
      <motion.form
        onSubmit={handleSubmit(onSubmit)}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white max-w-8xl mx-auto rounded-3xl shadow-xl p-6 md:p-10 relative space-y-8"
      >
        <motion.h2
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="text-2xl md:text-2xl font-bold text-gray-800 mb-6 border-b pb-2"
        >
          {helpers.ternaryCondition(location?.pathname == '/service-price-manager/edit', 'Edit', helpers.ternaryCondition(location?.pathname == '/service-manager/add', 'Add', 'View'))} Service Price
        </motion.h2>

        <div className="flex flex-col lg:flex-row gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="w-full h-full transition-shadow duration-300"
          >
            <div className="w-full transition-shadow duration-300">
              <div className="bg-white shadow-md rounded-2xl p-6">
                <div className=" p-1 max-h-[500px] overflow-y-auto ">
                  <div className="grid grid-cols-1 2xl:grid-cols-1 gap-6 ">
                    {/* Price Section */}
                    <div className="flex flex-col gap-4 border border-gray-200 rounded-xl p-4 bg-gray-50">
                      <div className="grid grid-cols-1 2xl:grid-cols-3 gap-6 ">

                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="name"
                          placeholder="Enter Service Name"
                          inputLabel={
                            <>
                              {t("Service Name")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          register={register("name")}

                          errors={errors}
                          disable={true}
                        />
                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="description"
                          placeholder="Enter Service Description"
                          inputLabel={
                            <>
                              {t("Service Description")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="text"
                          register={register("description")}

                          errors={errors}
                          disable={true}
                        />


                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="basePrice"
                          placeholder="Enter Base Price"
                          inputLabel={
                            <>
                              {t("Base Price")} ($)
                              <span className="text-red-500">*</span>
                            </>
                          }
                          type="number"
                          register={register("basePrice", {
                            required: t("BASE_PRICE_IS_REQUIRED"),
                            min: { value: defaultValue?.minBasePrice || 1, message: `Value must be greater than $${(defaultValue?.minBasePrice - 1) || 0}.` },
                            max: { value: defaultValue?.maxBasePrice || 10000, message: `Value cannot be greater than $${defaultValue?.maxBasePrice || 10000}.` },
                            onChange: (e) => {
                              e.target.value = e?.target?.value?.replace(/\D/g, "");
                            },
                            valueAsNumber: true,
                          })}
                          onKeyDown={(e) => {
                            if ([".", ",", "e", "-"].includes(e.key)) e.preventDefault();
                          }}
                          errors={errors}
                          disable={isView}
                        />

                      </div>
                    </div>


                    <motion.div
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.3 }}
                      className="w-full mt-4 transition-shadow duration-300 "
                    >
                      <h2 className="text-[23px] font-bold text-gray-800 mb-6 border-b pb-3">
                        {t("PRICE_INCREMENT_AS_PER_RADIUS")}
                      </h2>
                      <div className="">
                        {fields2?.map((item, index) => (
                          <div key={`${index}`} className="space-y-2 px-1 rounded-2xl border border-gray-200  bg-gray-50 shadow-md pb-1 mb-3 pt-1">
                            <motion.div
                              key={item.id}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.05 }}
                              className="p-4 border-b last:border-b-0 relative"
                            >

                              <div className="flex gap-3">
                                <div className="w-[95%] grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-3 gap-6">
                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="min"
                                    placeholder="Enter Min Distance"
                                    inputLabel={
                                      <>
                                        {t("Min Distance")} (Miles)
                                        <span className="text-red-500">*</span>
                                      </>
                                    }
                                    type="number"
                                    value={helpers.ternaryCondition(
                                      index == 0,
                                      0,
                                      Number(watch(`priceIncrementAsPerDistance.${index - 1}.max`,))
                                    )}
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.min`,
                                      {
                                        onChange: (e) => {
                                          e.target.value = e?.target?.value?.replace(
                                            /\D/g,
                                            ""
                                          );
                                        },
                                        valueAsNumber: true,
                                      }
                                    )}
                                    onKeyDown={(e) => {
                                      if ([".", ",", "e", "-"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    errors={errors?.priceIncrementAsPerDistance?.[index]}
                                    disable={true}
                                  />


                                  {/* hidden */}
                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group hidden"
                                    name="min"
                                    placeholder="Enter Min Distance"
                                    inputLabel={
                                      <>
                                        {t("Min Distance")} (Miles)
                                        <span className="text-red-500">*</span>
                                      </>
                                    }
                                    type="number"
                                    value={helpers.ternaryCondition(
                                      index == 0,
                                      0,
                                      Number(watch(`priceIncrementAsPerDistance.${index - 1}.max`,))
                                    )}
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.min`,
                                      {
                                        onChange: (e) => {
                                          e.target.value = e?.target?.value?.replace(
                                            /\D/g,
                                            ""
                                          );
                                        },
                                        valueAsNumber: true,
                                      }
                                    )}
                                    onKeyDown={(e) => {
                                      if ([".", ",", "e", "-"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    errors={errors?.priceIncrementAsPerDistance?.[index]}
                                    disable={true}
                                  />
                                  {/* hidden */}

                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="max"
                                    placeholder="Enter Max Distance"
                                    inputLabel={
                                      <>
                                        {t("Max Distance")} (Miles)
                                        <span className="text-red-500">*</span>
                                      </>
                                    }
                                    type="number"
                                    register={register(`priceIncrementAsPerDistance.${index}.max`, {
                                      required: t("Max distance is required."),
                                      min: {
                                        value:
                                          watch(`priceIncrementAsPerDistance.${index}.min`) + 1,
                                        message:
                                          "Value must be greater than " +
                                          watch(`priceIncrementAsPerDistance.${index}.min`) +
                                          ".",
                                      },
                                      max: {
                                        value: 100000,
                                        message: "Value cannot be greater than 100000.",
                                      },
                                      onChange: (e) => {
                                        e.target.value = e?.target?.value?.replace(
                                          /\D/g,
                                          ""
                                        );
                                        clearErrors(`priceIncrementAsPerDistance.${index}.max`);
                                      },
                                      valueAsNumber: true,
                                    })}
                                    onKeyDown={(e) => {
                                      if ([".", ",", "e", "-"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    errors={errors?.priceIncrementAsPerDistance?.[index]}
                                    disable={true}
                                  />

                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name={"percentage"}
                                    placeholder="Enter Price Increment"
                                    inputLabel={
                                      <>
                                        {t("Price Increment")} (%)
                                        <span className="text-red-500">*</span>
                                      </>
                                    }
                                    type="number"
                                    register={register(`priceIncrementAsPerDistance.${index}.percentage`, {
                                      required: t("Price increment is required."),
                                      min: {
                                        value: defaultValue?.priceIncrementAsPerDistance?.[index]?.minPercentage || 1,
                                        message:
                                          `Value must be greater than ${(defaultValue?.priceIncrementAsPerDistance?.[index]?.minPercentage - 1) || 0}.`,
                                      },
                                      max: {
                                        value: defaultValue?.priceIncrementAsPerDistance?.[index]?.maxPercentage || 100,
                                        message: `Value cannot be greater than ${(defaultValue?.priceIncrementAsPerDistance?.[index]?.maxPercentage) || 100}.`,
                                      },
                                      onChange: (e) => {
                                        e.target.value = e?.target?.value?.replace(
                                          /\D/g,
                                          ""
                                        );
                                      },
                                      valueAsNumber: true,
                                    })}
                                    onKeyDown={(e) => {
                                      if ([".", ",", "e", "-"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    errors={errors?.priceIncrementAsPerDistance?.[index]}
                                    disable={isView}
                                  />

                                </div>

                               {helpers.andOperator(index>0,
                                 <div className="">
                                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t("STATUS")}
                                  </label>

                                  <div className="mt-[15px]">
                                    <label
                                      className="relative inline-flex items-center cursor-pointer"
                                      title={helpers.ternaryCondition(watch(`priceIncrementAsPerDistance.${index}.status`), "Active", "Inactive")}
                                    >
                                      <input
                                        type="checkbox"
                                        className="sr-only peer"
                                        disabled={(index > 0 && !watch(`priceIncrementAsPerDistance.${index - 1}.status`)) || isView}
                                        {...register(`priceIncrementAsPerDistance.${index}.status`,{onChange:(e)=>{handleStatusChange(e, index)}})}
                                      />
                                      <div className={`w-10 h-5 bg-gray-200  peer peer-focus:ring-0  dark:peer-focus:ring-blue-800 peer-focus:ring-blue-300 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-gradientTo  ${(index > 0 && !watch(`priceIncrementAsPerDistance.${index - 1}.status`)) || isView ? 'opacity-50 cursor-not-allowed': ''}`}></div>
                                    </label>
                                  </div>
                                </div>)}

                              </div>
                            </motion.div>
                          </div>
                        ))}
                      </div>
                    </motion.div>

                    {location?.state?.isdropLocation && <motion.div
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.3 }}
                      className="w-full mt-4 transition-shadow duration-300 "
                    >
                      <h2 className="text-[23px] font-bold text-gray-800 mb-6 border-b pb-3">
                        {t("DROPOFF_INFORMATION")}
                      </h2>

                      <div className="">
                        {fields1?.map((item, index) => (
                      <div key={`${index}`} className="space-y-2 px-1 rounded-2xl border border-gray-200  bg-gray-50 shadow-md pb-1 mb-3 pt-1">
                            <motion.div
                              key={item.id}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.05 }}
                              className="p-4 border-b last:border-b-0 relative"
                            >
                              <div className="flex gap-3">
                              <div className="w-[95%] grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-3 gap-6">
                                <OInputField
                                  wrapperClassName="relative z-0 w-full group"
                                  name="startDistance"
                                  placeholder="Enter Start Distance"
                                  inputLabel={
                                    <>
                                      {t("Start Distance")} (Miles)
                                      <span className="text-red-500">*</span>
                                    </>
                                  }
                                  type="number"

                                  value={helpers.ternaryCondition(
                                    index == 0,
                                    0,
                                    Number(watch(`price.${index - 1}.endDistance`))
                                  )}
                                  register={register(
                                    `price.${index}.startDistance`,
                                    {
                                      onChange: (e) => {
                                        e.target.value = e?.target?.value?.replace(
                                          /\D/g,
                                          ""
                                        );
                                      },
                                      valueAsNumber: true,
                                    }
                                  )}
                                  onKeyDown={(e) => {
                                    if ([".", ",", "e", "-"].includes(e.key))
                                      e.preventDefault();
                                  }}
                                  errors={errors?.price?.[index]}
                                  disable={true}
                                />

                                <OInputField
                                  wrapperClassName="relative z-0 w-full group"
                                  name="endDistance"
                                  placeholder="Enter End Distance"
                                  inputLabel={
                                    <>
                                      {t("End Distance")} (Miles)
                                      <span className="text-red-500">*</span>
                                    </>
                                  }
                                  type="number"
                                  register={register(`price.${index}.endDistance`, {
                                    required: t("End distance is required."),
                                    min: {
                                      value:
                                        watch(`price.${index}.startDistance`) + 1,
                                      message:
                                        "Value must be greater than " +
                                        watch(`price.${index}.startDistance`) +
                                        ".",
                                    },
                                    max: {
                                      value: 1000,
                                      message: "Value cannot be greater than 1000.",
                                    },
                                    onChange: (e) => {
                                      e.target.value = e?.target?.value?.replace(
                                        /\D/g,
                                        ""
                                      );
                                      clearErrors(`price.${index}.endDistance`);
                                    },
                                    valueAsNumber: true,
                                  })}
                                  onKeyDown={(e) => {
                                    if ([".", ",", "e", "-"].includes(e.key))
                                      e.preventDefault();
                                  }}
                                  errors={errors?.price?.[index]}
                                  disable={true}
                                />

                                <OInputField
                                  wrapperClassName="relative z-0 w-full group"
                                  name={"price"}
                                  placeholder="Enter Service Price"
                                  inputLabel={
                                    <>
                                      {t("Service Price")} ($)
                                      <span className="text-red-500">*</span>
                                    </>
                                  }
                                  type="number"
                                  register={register(`price.${index}.price`, {
                                    required: t("SERVICE_PRICE_IS_REQUIRED"),
                                    min: {
                                      value: defaultValue?.dropOffPriceIncrementAsPerDistance?.[index]?.minPrice || 1,
                                      message:
                                        `Value must be greater than $${(defaultValue?.dropOffPriceIncrementAsPerDistance?.[index]?.minPrice - 1) || 0}.`

                                    },
                                    max: {
                                      value: defaultValue?.dropOffPriceIncrementAsPerDistance?.[index]?.maxPrice || 100000,
                                      message: `Value cannot be greater than $${defaultValue?.dropOffPriceIncrementAsPerDistance?.[index]?.maxPrice || 100000}.`,
                                    },
                                    onChange: (e) => {
                                      e.target.value = e?.target?.value?.replace(
                                        /\D/g,
                                        ""
                                      );
                                    },
                                    valueAsNumber: true,
                                  })}
                                  onKeyDown={(e) => {
                                    if ([".", ",", "e", "-"].includes(e.key))
                                      e.preventDefault();
                                  }}
                                  errors={errors?.price?.[index]}
                                  disable={isView}
                                />

                              </div>

                              {helpers.andOperator(index>0,
                                 <div className="">
                                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t("STATUS")}
                                  </label>

                                  <div className="mt-[15px]">
                                    <label
                                      className="relative inline-flex items-center cursor-pointer"
                                      title={helpers.ternaryCondition(watch(`price.${index}.status`), "Active", "Inactive")}
                                    >
                                      <input
                                        type="checkbox"
                                        className="sr-only peer"
                                        disabled={index > 0 && !watch(`price.${index - 1}.status`)}
                                        {...register(`price.${index}.status`,{onChange:(e)=>{handleStatusChangeDrop(e, index)}})}
                                      />
                                      <div className={`w-10 h-5 bg-gray-200  peer peer-focus:ring-0  dark:peer-focus:ring-blue-800 peer-focus:ring-blue-300 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-gradientTo  ${index > 0 && !watch(`price.${index - 1}.status`)? 'opacity-50 cursor-not-allowed': ''}`}></div>
                                    </label>
                                  </div>
                                </div>)}
                                </div>
                            </motion.div>
                          </div>
                        ))}
                      </div>
                    </motion.div>}
                  </div>
                </div>
              </div>
            </div>

          </motion.div>
        </div>
        <div className="flex gap-4 justify-center">

          <Link to='/service-price-manager'>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="button"
              title={'Back'}
              onClick={() => reset()}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition flex items-center gap-1"
            >
              <IoCaretBackCircleOutline size={18} />{t('O_BACK')}
            </motion.button>
          </Link>

          {helpers.andOperator(!isView, <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            title={'Submit'}
            type="submit"
            className="px-6 py-2 bg-gradientTo text-sm text-white rounded-md  transition flex items-center gap-1"
            disabled={isPending}
          >
            {helpers.ternaryCondition(isPending, 'Submiting...', <>{t('Submit')}</>)}
          </motion.button>)}
        </div>
      </motion.form>
    </div>
  );
}
